module.exports = __webpack_public_path__ + "img/16m004-03.88ec5f6c.png";